module.exports = __webpack_public_path__ + "static/media/logo-pegada-ambiental-escuro.99811d81.png";